import _ from 'lodash'
import store from '@/store'
import { getUserInfo } from '@/api/auth'
import { SET_USER_INFO } from '@/utils/constants'

function parseQueryStr(queryStr) {
  if (queryStr.length <= 0) {
    return {}
  }
  const result = {}
  const strPairs = queryStr.split('&')
  strPairs.forEach((str) => {
    const pair = str.split('=')
    result[pair[0]] = pair[1]
  })
  return result
}

export default async function (to, from, next) {
  // Update document.title
  document.title = to.meta.title || '权限系统'

  // 特别处理智慧工厂的权限
  if (window.location.search.length > 1) {
    const query = parseQueryStr(window.location.search.substring(1))
    if (query.sys) {
      window.sessionStorage.setItem('sys', query.sys)
    }
  } else if (to.query.sys) {
    window.sessionStorage.setItem('sys', to.query.sys)
  }

  const whiteList = new Set(['login-view', 'reset-view', 'register-view', 'registration-agreement'])
  if (whiteList.has(to.name)) {
    next()
    return
  }

  // Check user info
  if (_.isEmpty(store.state.userInfo)) {
    const userInfo = await getUserInfo()
    store.commit(SET_USER_INFO, userInfo)
  }

  next()

  // Check permission
  // if (to.name === 'permission-denied') {
  //   next()
  // } else if (!store.getters.checkPermission(PERMISSION_SYSTEM)) {
  //   next({
  //     name: 'permission-denied',
  //   })
  // } else if (
  //   to.meta && to.meta.permission
  //   && !store.getters.checkPermission(to.meta.permission)
  // ) {
  //   next({
  //     name: 'permission-denied',
  //   })
  // } else {
  //   next()
  // }
}
